'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useState } from 'react';
import { Toaster } from '@/components/ui/sonner';
import type { DesktopControlBarSurface } from '@/constants/control-bar';
export type ControlBarViewportLayoutProps = {
  barPlacement: 'before' | 'after';
  children: ReactNode;
  className: string;
  dataComponent?: 'control-bar-layout' | 'embedded-control-bar-layout' | 'mobile-control-bar-layout';
  dataControlBarHidden?: boolean;
  dataOrientation?: 'landscape' | 'portrait';
  dataSurface?: DesktopControlBarSurface;
  renderControlBar: (popupContainer: HTMLDivElement | null) => ReactNode;
  showToaster?: boolean;
  viewportDataComponent?: 'control-bar-viewport' | 'embedded-control-bar-viewport' | 'mobile-control-bar-viewport';
};
export default function ControlBarViewportLayout(t0) {
  const $ = _c(18);
  const {
    barPlacement,
    children,
    className,
    dataComponent,
    dataControlBarHidden,
    dataOrientation,
    dataSurface,
    renderControlBar,
    showToaster: t1,
    viewportDataComponent
  } = t0;
  const showToaster = t1 === undefined ? true : t1;
  const [popupContainer, setPopupContainer] = useState(null);
  let t2;
  if ($[0] !== popupContainer || $[1] !== renderControlBar) {
    t2 = renderControlBar(popupContainer);
    $[0] = popupContainer;
    $[1] = renderControlBar;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const controlBar = t2;
  const t3 = barPlacement === "before" && controlBar;
  let t4;
  if ($[3] !== showToaster) {
    t4 = showToaster && <Toaster toastOptions={{
      className: "hidden [:fullscreen_&]:block"
    }} />;
    $[3] = showToaster;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4 || $[7] !== viewportDataComponent) {
    t5 = <div ref={setPopupContainer} data-component={viewportDataComponent} className="relative min-h-0 min-w-0 flex-1 bg-black in-data-[transparent-background]:bg-transparent">{children}{t4}</div>;
    $[5] = children;
    $[6] = t4;
    $[7] = viewportDataComponent;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = barPlacement === "after" && controlBar;
  let t7;
  if ($[9] !== className || $[10] !== dataComponent || $[11] !== dataControlBarHidden || $[12] !== dataOrientation || $[13] !== dataSurface || $[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div data-component={dataComponent} data-surface={dataSurface} data-control-bar-hidden={dataControlBarHidden} data-orientation={dataOrientation} className={className}>{t3}{t5}{t6}</div>;
    $[9] = className;
    $[10] = dataComponent;
    $[11] = dataControlBarHidden;
    $[12] = dataOrientation;
    $[13] = dataSurface;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}